// Prismic	
let Prismic = require('prismic-javascript');
let title = document.querySelector('h1')
let first_paragraphe = document.querySelector('#first_paragraphe')
let second_title = document.querySelector('h2')
let second_paragraphe = document.querySelector('#second_paragraphe')
 
let apiEndpoint = "https://olivier-geffard.prismic.io/api/v2";
 
Prismic.getApi(apiEndpoint).then(function(api) {
  return api.getByID('XiV6lhAAACIA0pmY'); // An empty query will return all the documents
}).then(function(response) {
  // Add title
  title.innerHTML = response.data.title[0].text

  // Add texts
  response.data.first_paragraphe.forEach(paragraphe => {
    let conteneur = document.createElement('p')
    if (paragraphe.spans.length > 0) {
        let text = paragraphe.text
        paragraphe.spans.forEach((span, index) => {
            if (span.type == "strong") {
                let spanConteneur = document.createElement('span')
                spanConteneur.classList.add('bold')
                let spanConteneurText = paragraphe.text.substring(span.start, span.end)
                spanConteneurText = spanConteneurText.slice(0,1) + spanConteneurText.slice(1).replace(/\n/g, "<br />")
                spanConteneur.innerHTML = spanConteneurText
                if (index == 0) {
                    conteneur.innerHTML = text.slice(0, span.start)
                } else {
                    conteneur.insertAdjacentHTML('beforeend', text.slice(paragraphe.spans[index - 1].end, span.start))
                }
                conteneur.appendChild(spanConteneur)
                if (index == paragraphe.spans.length - 1) {
                    console.log(text.slice(span.end))
                    conteneur.insertAdjacentHTML('beforeend', text.slice(span.end).replace(/\n/g, "<br />"))
                }
                // else {
                //     conteneur.insertAdjacentHTML('beforeend', text.slice(span.end, paragraphe.spans[index + 1].start))
                // }
            } else if (span.type == "hyperlink") {
                let link = document.createElement('a')
                link.setAttribute('href', span.data.url)
                link.innerHTML = paragraphe.text.substring(span.start, span.end)
                conteneur.appendChild(link)
            }
        })
        first_paragraphe.appendChild(conteneur)
    } else {
        conteneur.innerHTML = paragraphe.text
        first_paragraphe.appendChild(conteneur)
    }
    })
    // Add image
    let image = document.createElement('img')
    image.setAttribute('src', response.data.first_paragraphe_image.url)
    first_paragraphe.parentNode.appendChild(image)

    // Add second Title
    second_title.innerHTML = response.data.second_title[0].text

    // Add second paragraphe
    response.data.second_paragraphe.forEach(paragraphe => {
        let conteneur = document.createElement('p')
        if (paragraphe.spans.length > 0) {
            let text = paragraphe.text
            paragraphe.spans.forEach((span, index) => {
                if (span.type == "strong") {
                    let spanConteneur = document.createElement('span')
                    spanConteneur.classList.add('bold')
                    let spanConteneurText = paragraphe.text.substring(span.start, span.end)
                    spanConteneurText = spanConteneurText.slice(0,1) + spanConteneurText.slice(1).replace(/\n/g, "<br />")
                    spanConteneur.innerHTML = spanConteneurText
                    if (index == 0) {
                        conteneur.innerHTML = text.slice(0, span.start)
                    } else {
                        conteneur.insertAdjacentHTML('beforeend', text.slice(paragraphe.spans[index - 1].end, span.start))
                    }
                    conteneur.appendChild(spanConteneur)
                    if (index == paragraphe.spans.length - 1) {
                        conteneur.insertAdjacentHTML('beforeend', text.slice(span.end).replace(/\n/g, "<br />"))
                    } else {
                        conteneur.insertAdjacentHTML('beforeend', text.slice(span.end, paragraphe.spans[index + 1].start))
                    }
                } else if (span.type == "hyperlink") {
                    let link = document.createElement('a')
                    link.setAttribute('href', span.data.url)
                    link.innerHTML = paragraphe.text.substring(span.start, span.end)
                    conteneur.appendChild(link)
                }
            })
            second_paragraphe.appendChild(conteneur)
        } else {
            conteneur.innerHTML = paragraphe.text
            second_paragraphe.appendChild(conteneur)
        }
        })

    // Add second image
    let image2 = document.createElement('img')
    image2.setAttribute('src', response.data.second_paragraphe_image.url)
    second_paragraphe.parentNode.appendChild(image2)

}, function(err) {
  console.log("Something went wrong: ", err);
});